import {
  Button,
  Grid,
} from "@mui/material";

import Section from "./components/Section";
import DetailGrid from "./components/DetailGrid"
import DistributorCustomBidfloorForm from "./forms/DistributorCustomBidfloorForm";

import { useState } from "react";

const getDetailGridProps = ({ custom_bidfloor, isEditing, formProps }) => {
  const firstColumn = {
    title: "Bid Floor (CPM)",
    description: (
      !isEditing ?
      ((custom_bidfloor && `$${custom_bidfloor}`) ?? "N/A")
      : (<DistributorCustomBidfloorForm customBidfloor={custom_bidfloor} {...formProps} />)
    )
  }

  const props = {
    PaperProps: { sx: { backgroundColor: "white" } },
    disableBadge: true,
    columns: [
      firstColumn,
      { title: "Description", description: "Fixed floor applied to outgoing bid requests to third-party programmatic demand if the incoming bid request from the mediator is absent" }
    ]
  }

  return props
}

const EditButton = ({ onClick }) => (
  <Button sx={{ alignSelf: "self-end" }} variant="contained" size="small" onClick={onClick}>Edit</Button>
)

const DistributorCustomBidfloorSection = ({ distributor }) => {
  const [isEditing, setIsEditing] = useState(false);

  const handleEditClick = (event) => setIsEditing((prev) => !prev);
  const hideEditForm = () => setIsEditing(false);

  return (
    <Section title={"Custom Bid Floor"} actionButton={<EditButton onClick={handleEditClick} />}>
      <Grid container item xs={12}>
        <Grid item xs={12} sx={{ borderRadius: 2, display: "flex", flexDirection: "row" }}>
          <DetailGrid {...getDetailGridProps({ isEditing, ...distributor, formProps: { onCancel: hideEditForm } })} />
        </Grid>
      </Grid>
    </Section>
  )
}

export default DistributorCustomBidfloorSection;
